
/* eslint-disable */
// @ts-nocheck
// @ts-ignore

import * as srvoption from './srvoption.proto';


export const enum SPECIAL_ROLE_TPL_ID {
  TPL_ID_NOT_USE = 0,
  TPL_ID_NORMAL = 1,
  TPL_ID_ADMIN = 2,
  TPL_ID_DEVELOPER = 3,
  TPL_ID_GROUP_OWNER = 5,
  TPL_ID_BOT_ADMIN = 6,
  TPL_ID_BOT_GROUP = 7,
}

export const enum SPECIAL_ROLE_ID {
  ID_NOT_USE = 0,
  ID_NORMAL = 1,
  ID_ADMIN = 2,
  ID_DEVELOPER = 3,
  ID_OFFICIAL_ADMIN = 4,
  ID_GROUP_OWNER = 5,
  ID_BOT_ADMIN = 6,
  ID_BOT_GROUP = 7,
}

export const enum ROLE_TYPE {
  TY_NOT_USE = 0,
  TY_USER = 1,
  TY_BOT = 2,
  TY_BOT_GROUP = 3,
}

export const enum ROLE_SET_TYPE {
  ROLE_SET_NOT_USE = 0,
  ROLE_SET_NONE = 1,
  ROLE_SET_GROUP = 2,
  ROLE_SET_BOT = 3,
  ROLE_SET_CHANNEL = 4,
  ROLE_SET_CHANNEL_USER = 5,
}

export const enum ALTER_USER_ROLE_SCOPE {
  ALTER_USER_ROLE_COMMON = 0,
  ALTER_USER_ROLE_QUIT_GRP = 1,
  ALTER_USER_ROLE_ACCOUNT_CANCEL = 2,
  ALTER_USER_ROLE_JOIN_GRP = 3,
  ALTER_USER_ROLE_BOT_LABEL = 4,
  ALTER_USER_ROLE_CRT_GRP = 5,
  ALTER_USER_ROLE_JOIN_GRP_ROLLBACK = 6,
  ALTER_USER_ROLE_TRANSFER_GRP = 7,
}

export interface PermsStorage {
  /** 权限id */
  id: string;
  /** 权限名称 */
  name: string;
  /** 权限所属模块 */
  mod: string;
  /** 权限标志、路径 */
  tag: string;
  /** 权限描述 */
  description: string;
  /** 排序，越小越靠前 */
  weight: string;
  /** 创建时间戳 */
  created: string;
  /** 修改时间戳 */
  modified: string;
  /** 子权限id集合 */
  subPerms: Array<string>;
}

export interface RoleStorage {
  /** 角色id */
  id: string;
  /** 角色名称 */
  name: string;
  /** 所属群组 */
  groupId: string;
  /** 角色描述 */
  description: string;
  /** 排序，越小越靠前 */
  weight: string;
  /** 创建时间戳 */
  created: string;
  /** 修改时间戳 */
  modified: string;
  /** 角色拥有的权限id列表 */
  permsIds: Array<string>;
  /** 角色的类型，参考ROLE_TYPE定义 */
  type: ROLE_TYPE;
  /** 角色集合类型 */
  setType: ROLE_SET_TYPE;
  /** 角色集合ID，set_type=2，填写gid,set_type=4，5，填写对应channelID */
  setId: string;
  /** 关联ID，set_type=4,填写原有角色ID，set_type=5,填写UID */
  relateId: string;
  /** 角色颜色 */
  color: string;
  /** 是否展示角色 */
  isShow: boolean;
  /** 权限组ID列表 */
  permsSetIds: Array<string>;
  /** 是否展示在终端 */
  external: boolean;
  /** 关联的模板ID */
  tplId: string;
  /** 角色外显配置 */
  display: RoleDisplay;
  /** 角色限时配置 */
  expire: RoleExpire;
}

export interface UserRoleStorage {
  /** 角色id */
  id: Array<string>;
  /** 用户自定义外显角色ID */
  displayId: string;
}

export interface Perms {
  /** 权限id */
  id: string;
  /** 权限名称 */
  name: string;
  /** 权限所属模块 */
  mod: string;
  /** 权限标志、路径 */
  tag: string;
  /** 权限描述 */
  description: string;
  /** 排序，越小越靠前 */
  weight: string;
}

export interface Role {
  /** 角色id */
  id: string;
  /** 角色名称 */
  name: string;
  /** 所属群组 */
  groupId: string;
  /** 角色拥有的权限id列表 */
  permsIds: Array<string>;
  /** 角色的类型，参考ROLE_TYPE定义 */
  type: ROLE_TYPE;
  /** 排序，越小越靠前 */
  weight: string;
  /** 角色集合类型 */
  setType: ROLE_SET_TYPE;
  /** 角色集合ID，set_type=2，填写gid,set_type=4，5，填写对应channelID */
  setId: string;
  /** 关联ID，set_type=4,填写原有角色ID，set_type=5,填写UID */
  relateId: string;
  /** 角色颜色 */
  color: string;
  /** 角色拥有的成员数量 */
  totalNum: string;
  /** 是否展示在用户列表 */
  isShow: boolean;
  /** 权限组ID列表 */
  permsSetIds: Array<string>;
  /** 是否展示在终端 */
  external: boolean;
  /** 关联的模板ID */
  tplId: string;
  /** 角色外显配置 */
  display: RoleDisplay;
  /** 角色限时配置 */
  expire: RoleExpire;
}

export interface PermsIDList {
  /** 权限ID */
  ids: Array<string>;
}

export interface PermsSet {
  /** 权限组ID */
  id: string;
  /** 权限组名称 */
  name: string;
  /** 权限组描述 */
  description: string;
  /** 权限组包括的权限ID列表 */
  permsIds: Array<string>;
  /** 0:都展示 1：只在群组权限展示 2：只在频道高级权限展示 */
  displayType: string;
}

export interface RoleTPL {
  /** 模板ID */
  id: string;
  /** 模板名称 */
  name: string;
  /** 模板描述 */
  description: string;
  /** 预设颜色库 */
  color: Array<string>;
  /** 预设权限组ID列表 */
  permsSetIds: Array<string>;
  /** 角色拥有的权限id列表 */
  permsIds: Array<string>;
  /** 是否展示角色 */
  isShow: boolean;
}

export interface ChgRoleMsg {
  /** 0:新增 1:修改 2:删除 */
  type: string;
  /** 角色ID */
  rid: string;
  /** 群组ID */
  gid: string;
  /** channelID */
  cid: string;
}

export interface ChgRoleUserMemMsg {
  /** 0:新增 1:删除 */
  type: string;
  /** 角色ID */
  rid: string;
  /** 群组ID */
  gid: string;
  /** channelID */
  cid: string;
  /** uid列表 */
  uidList: Array<string>;
}

export interface RoleDisplay {
  /** 角色标签 */
  label: RoleLabel;
}

export interface RoleLabel {
  /** id */
  id: string;
  /** 标签文案 */
  text: string;
  /** 是否开启 */
  open: boolean;
}

export interface RoleLabelCfg {
  /** id */
  id: string;
  /** 文字颜色 */
  textColor: string;
  /** 背景是否为固定颜色 */
  bgFixedColor: boolean;
  /** 缩放系数，切图倍图 x 2 */
  scale: number;
  /** 纯色、拉伸、颜色混合 */
  bgUrl: string;
  /** 彩色、拉伸、不混合 */
  coverUrl: string;
  /** 前景图宽度（像素） */
  coverWidth: string;
  /** 前景图高度（像素） */
  coverHeight: string;
  /** 背景图高度（像素） */
  bgHeight: string;
  /** 拉伸区域 */
  stretchAreaLeft: string;
  /** 拉伸区域 */
  stretchAreaTop: string;
  /** 拉伸区域 */
  stretchAreaRight: string;
  /** 拉伸区域 */
  stretchAreaBottom: string;
  /** 内容区域 */
  contentAreaLeft: string;
  /** 内容区域 */
  contentAreaTop: string;
  /** 内容区域 */
  contentAreaRight: string;
  /** 内容区域 */
  contentAreaBottom: string;
}

export interface RoleExpire {
  /** 是否开启 */
  open: boolean;
  /** 持续时长，以秒为单位 */
  duration: string;
  /** 开始时间戳，从该时间开始计算有效期 */
  startTime: string;
}
